import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarRef, TextOnlySnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { APIError } from '@smartcharge/shared/index';

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  constructor(
    private readonly snackbar: MatSnackBar,
    private readonly translate: TranslateService
  ) {}

  success(message: string, actionLabel: string = 'CLOSE'): MatSnackBarRef<TextOnlySnackBar> {
    return this.snackbar.open(this.translate.instant(message), this.translate.instant(actionLabel), {
      duration: 5000,
      panelClass: ['success']
    });
  }

  info(message: string, actionLabel: string = 'CLOSE'): MatSnackBarRef<TextOnlySnackBar> {
    return this.snackbar.open(this.translate.instant(message), this.translate.instant(actionLabel), {
      duration: 5000,
      panelClass: ['info']
    });
  }

  error(
    message: string | APIError = 'An error has occurred',
    actionLabel: string = 'CLOSE'
  ): MatSnackBarRef<TextOnlySnackBar> {
    if (typeof message === 'object') {
      message = message.errorName || message.message || 'An error has occurred';
    } else if (typeof message === 'string') {
      message = this.translate.instant(message);
    }

    return this.snackbar.open(
      this.translate.instant('SOMETHING_WENT_WRONG_WITH_ERROR', {
        errorName: message
      }),
      this.translate.instant(actionLabel),
      {
        duration: 10000,
        panelClass: ['error']
      }
    );
  }
}
